import { render, staticRenderFns } from "./LibraryBookFormat.vue?vue&type=template&id=dcff0778&"
import script from "./LibraryBookFormat.vue?vue&type=script&lang=js&"
export * from "./LibraryBookFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports